import { render } from "./mythVsFactFour.vue?vue&type=template&id=d1861bc6"
import script from "./mythVsFactFour.vue?vue&type=script&lang=js"
export * from "./mythVsFactFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__